import { useState, useEffect, useContext } from "react";
import { UserContext } from "../context/userContext";

export function useFieldSupportStatus() {
  const [isFieldSupport, setIsFieldSupport] = useState(false);
  const { user } = useContext(UserContext);
  const { userType } = user || {};

  useEffect(() => {
    setIsFieldSupport(userType === "field_view");

    return () => setIsFieldSupport(false);
  });

  return isFieldSupport;
}
